import React from 'react';
import {  Dialog, DialogContent, makeStyles, Paper } from "@material-ui/core";
import Draggable from 'react-draggable';
import DialogCloseableTitle from '../DialogCloseableTitle';

const useStyles = makeStyles((theme)=> ({
    dialog: {
        zIndex: theme.zIndex.drawer - 10
    }
}))

const PaperComponent = (props) => {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'} defaultPosition={{x: 0, y: window.innerHeight / 2 * 0.75}}>
            <Paper {...props}/>
        </Draggable>
    );
}


function FloatingDialog(props){
    const {open, onClose, children} = props
    const classes = useStyles()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperComponent={PaperComponent}
            hideBackdrop={true}
            disableBackdropClick={true}
            disableEnforceFocus
            style={{pointerEvents: 'none', zIndex: 10, marginBottom: '11vh'}}
            fullWidth
        >
            <DialogCloseableTitle onClose={onClose} style={{cursor: 'move', pointerEvents: 'all'}} id="draggable-dialog-title">
                {props.title}
            </DialogCloseableTitle>
            <DialogContent style={{pointerEvents: 'all'}}>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default FloatingDialog